import { fork, delay, call, put, all, takeLatest } from 'redux-saga/effects';
import { getStatus, getConfiguration } from 'services/moneyline';
import { Status, Configuration } from 'services/moneyline/moneyline.types';
import { getType } from 'typesafe-actions';
import {
  hardwareUpdate,
  hardwareUpdateFailed,
  requestHardwareUpdate,
} from './hardware.actions';

const HARDWARE_UPDATE_POLLING_INTERVAL = 1000 * 60 * 5;
const HARDWARE_UPDATE_ERROR_POLLING_INTERVAL = 1000 * 30;

function* updateHarwarehandler(): Saga {
  while (true) {
    try {
      const [status, configuration]: [Status, Configuration] = yield all([
        call(getStatus),
        call(getConfiguration),
      ]);
      yield put(hardwareUpdate(status, configuration));
      yield delay(HARDWARE_UPDATE_POLLING_INTERVAL);
    } catch (e) {
      yield put(hardwareUpdateFailed());
      yield delay(HARDWARE_UPDATE_ERROR_POLLING_INTERVAL);
    }
  }
}

export function* watchHardwareActions(): Saga {
  yield fork(updateHarwarehandler);
  yield takeLatest(getType(requestHardwareUpdate), updateHarwarehandler);
}
